import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nContext";
import { LOGO_LOCKUP, formatApiErrorDetail } from "@/lib/api";
import { Loader2, ArrowRight, ShieldCheck } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const signedIn = await login(email, password);
      navigate(signedIn.role === "STAFF" ? "/customer-operations" : "/today");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || t("login.signInFailed"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#070A12] grid-glow flex items-center justify-center px-4">
      <div className="w-full max-w-md rise">
        <div className="flex justify-center mb-8">
          <div className="relative h-[210px] w-[300px] overflow-hidden"><img src={LOGO_LOCKUP} alt="MASANDI AI LABS" className="absolute left-[-64px] top-[-83px] w-[600px] max-w-none" data-testid="login-logo" /></div>
        </div>
        <div className="m-card p-8">
          <p className="mono-label">SANDI GROUP · MASANDI AI LABS</p>
          <h1 className="font-display text-2xl font-extrabold text-white mt-2">{t("login.title")}</h1>
          <p className="text-sm text-[#94A3B8] mt-1">{t("login.subtitle")}</p>

          <form onSubmit={submit} className="mt-7 space-y-4">
            <div>
              <label className="mono-label">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="input-dark w-full h-11 px-4 mt-1.5 text-sm" data-testid="login-email-input" />
            </div>
            <div>
              <label className="mono-label">{t("login.password")}</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="input-dark w-full h-11 px-4 mt-1.5 text-sm" placeholder="••••••••" data-testid="login-password-input" />
            </div>
            {error && <p className="text-sm text-[#FB7185]" data-testid="login-error">{error}</p>}
            <button type="submit" disabled={loading} className="btn-primary w-full h-11 flex items-center justify-center gap-2 text-sm disabled:opacity-60" data-testid="login-submit-button">
              {loading ? <Loader2 size={16} className="animate-spin" /> : <>{t("login.enter")} <ArrowRight size={16} /></>}
            </button>
          </form>
        </div>
        <p className="text-center text-[11px] text-[#64748B] mt-6 flex items-center justify-center gap-1.5">
          <ShieldCheck size={13} /> {t("login.footer")}
        </p>
      </div>
    </div>
  );
}
